/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Insights_Lpprofile_Deals_Tab_Passed2Inputs */

const en_coinvestments_insights_lpprofile_deals_tab_passed2 = /** @type {(inputs: Coinvestments_Insights_Lpprofile_Deals_Tab_Passed2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passed (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Passed ({count})" |
*
* @param {Coinvestments_Insights_Lpprofile_Deals_Tab_Passed2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpprofile_deals_tab_passed2 = /** @type {((inputs: Coinvestments_Insights_Lpprofile_Deals_Tab_Passed2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpprofile_Deals_Tab_Passed2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpprofile_deals_tab_passed2(inputs)
});
export { coinvestments_insights_lpprofile_deals_tab_passed2 as "coInvestments_insights_lpProfile_deals_tab_passed" }